import api from './api';

// 기본정보 조회
export const getBasicInfo = async () => {
  const response = await api.get('/user/basic-info/');
  return response.data;
};

// 기본정보 저장
export const saveBasicInfo = async (data) => {
  const response = await api.post('/user/basic-info/', data);
  return response.data;
};

// 부양가족 정보 조회
export const getDependents = async () => {
  const response = await api.get('/user/dependents/');
  return response.data;
};

// 부양가족 정보 저장
export const saveDependents = async (dependents) => {
  const response = await api.post('/user/dependents/', { dependents });
  return response.data;
};

// 공제자료 파일 조회
export const getDeductionFiles = async () => {
  const response = await api.get('/user/deduction-files/');
  return response.data;
};

// 공제자료 파일 업로드
export const uploadDeductionFiles = async (files) => {
  const formData = new FormData();
  files.forEach((file) => {
    formData.append('files', file);
  });
  const response = await api.post('/user/deduction-files/', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

// 공제자료 파일 삭제
export const deleteDeductionFile = async (fileId) => {
  const response = await api.delete(`/user/deduction-files/${fileId}/`);
  return response.data;
};

